module.exports = __webpack_public_path__ + "img/btn.b0d16bc9.svg";